import React from "react"

import styled from "styled-components/native"

import tokens from "@treefort/tokens/app"

export type Spacing = keyof typeof tokens.spacing | number

const StyledSpacer = styled.View<{ $size: Spacing; $horizontal?: boolean }>`
  flex-shrink: 0;
  ${(props) => (props.$horizontal ? "width" : "height")}: ${(props) =>
    typeof props.$size === "number"
      ? props.$size
      : props.theme.spacing[props.$size]}px;
`

/**
 * @deprecated Use the gap prop on a Column or Row component
 */
export default function Spacer(props: { size: Spacing; horizontal?: boolean }) {
  return <StyledSpacer $size={props.size} $horizontal={props.horizontal} />
}
